import { DataProp } from 'editorjs-blocks-react-renderer';

export const generateShortDescription = (product: {
  seoDescription?: string | null;
  description?: string | null;
}) => {
  if (product.seoDescription) {
    return product.seoDescription;
  }

  if (product.description) {
    const parsedDescription = JSON.parse(product.description || '{}') as DataProp;

    if (parsedDescription.blocks && parsedDescription.blocks.length > 0) {
      return parsedDescription.blocks[0].data.text;
    }
  }

  return null;
};